import { array, boolean, literal, object, preprocess } from 'zod';

import { ProductGroupSchema, SpendBonusSchema } from '@occc/validation';

import { BaseSweepstakesSchema } from './base-sweepstakes.schema';

import { SweepstakesType } from '../types';

export const SpendBonusEarningMechanismSchema = SpendBonusSchema.extend({
  ineligibleProductGroups: array(ProductGroupSchema).optional(),
  stayVisibleWhileInProgress: object({ isEnabled: boolean() }).optional(),
});

export const SpendBonusFormSchema = BaseSweepstakesSchema.extend({
  sweepstakesType: literal(SweepstakesType.SpendBonus),
  spendBonus: preprocess((value) => value ?? {}, SpendBonusEarningMechanismSchema),
});
